import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { CardBody, Form, Row } from "reactstrap";
import { setBreadcrumbItems } from "store/actions";
import Spinners from "components/Common/Spinner";
import { Link, useParams } from "react-router-dom";
import * as url from "../../helpers/url_helper";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
const EditCategory = (props) => {
  const [isLoading, setLoading] = useState(false);
  const navigate = useNavigate();
  const breadcrumbItems = [
    { title: "VUF", link: "#" },
    { title: "Event", link: "#" },
    { title: "Event Category List", link: "#" },
    { title: "Edit Event Category", link: "#" },
  ];
  const { id } = useParams();
  const [categoryName, setCategoryName] = useState("");
  const [price, setPrice] = useState("");
  const [description, setDescription] = useState("");
  const [state, setState] = useState({});
  const { categoryid } = useParams();
  useEffect(() => {
    getCategoryDetail();
    props.setBreadcrumbItems("Edit Event Category", breadcrumbItems);
  }, []);
  function handleEventCategory(e) {
    e.preventDefault(); // Prevent default form submission
    setLoading(true);
    if (!categoryName || !price || !description) {
      return toast.warn("All field are required.");
    }
    const urlPath = `eventcategory/${id}/updateCategory/${categoryid}`;
    fetch(url.VUF_APP_API + urlPath, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        categoryname: categoryName,
        price: price,
        displayMsg: description,
        allowRegister: "true",
        eventId: id,
        status: "true",
      }),
    })
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData.status) {
          toast.success("Event Category Updated.");
          navigate("/Event/" + id + "/EventCategoryList");
        } else {
          toast.error("Something went wrong, please try again.");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        toast.error("Something went wrong, please try again.");
      })
      .finally((final) => {
        setLoading(false);
      });
  }

  const getCategoryDetail = () => {
    setLoading(true);
    let urlPath = "eventcategory/getCategoryDetails/" + categoryid;
    fetch(url.VUF_APP_API + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData.status) {
          var category = responseData.details;
          var data = {
            eventId: category.eventId,
            name: category.name || "--",
            price: category.price || "--",
            description: category.displayMsg,
            status: category.status ? "Active" : "Inactive",
          };
          setCategoryName(data.name);
          setPrice(data.price);
          setDescription(data.description);
        } else {
          toast.error(
            "Oops! \n\n Something went wrong, Please try again after sometime.",
          );
        }
      })
      .catch((error) => {})
      .finally((final) => {
        setLoading(false);
      });
  };
  return (
    <React.Fragment>
      {isLoading ? (
        <Spinners />
      ) : (
        <Row>
          <CardBody>
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="card card-custom gutter-b example example-compact">
                    <div className="card-header">
                      <h3 className="card-title">Edit Event Category</h3>
                    </div>
                    <div className="card-body row col-12">
                      <form onSubmit={handleEventCategory}>
                        <div className="col-md-12">
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group">
                                <label className="form-label">
                                  Event Category Name
                                </label>
                                <input
                                  type="text"
                                  onChange={(e) => {
                                    setCategoryName(e.target.value);
                                  }}
                                  className="form-control form-control-solid form-control"
                                  value={categoryName}
                                />
                                <span className="form-text text-danger"></span>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label className="form-label">
                                  Category Price:
                                </label>
                                <input
                                  type="number"
                                  onChange={(e) => {
                                    setPrice(e.target.value);
                                  }}
                                  className="form-control"
                                  value={price}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label className="form-label">
                                  Description
                                </label>
                                <textarea
                                  name="eventDescription"
                                  value={description}
                                  onChange={(e) =>
                                    setDescription(e.target.value)
                                  }
                                  className="form-control form-control-solid"
                                />
                                <span className="form-text text-danger"></span>
                              </div>
                            </div>
                          </div>
                          <div className="row mb-3">
                            <div className="col-md-2">
                              <div className="form-check form-switch">
                                <input
                                  id="customSwitch"
                                  type="checkbox"
                                  className="form-check-input form-check-input"
                                />
                                <label
                                  htmlFor="customSwitch"
                                  className="form-check-label form-label"
                                >
                                  Allow Register
                                </label>
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="form-check form-switch">
                                <input
                                  id="customSwitch"
                                  type="checkbox"
                                  className="form-check-input form-check-input"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="customSwitch"
                                >
                                  Status
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="d-flex gap-2">
                            <button
                              type="submit"
                              onSubmit={handleEventCategory}
                              className="btn btn-primary"
                            >
                              <i className="fa fa-plus me-2"></i>Edit Event
                              Category
                            </button>
                            <Link
                              className="btn btn-secondary"
                              to={`/Event/${id}/EventCategoryList`}
                            >
                              <i className="fa fa-arrow-left me-2"></i>Back to
                              List
                            </Link>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </CardBody>
        </Row>
      )}
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(EditCategory);
